

// src/api/douyin.js

import request from '@/plugins/request';
import axios from '@/plugins/axios';
export function douyin_aweme(params) {
    return request  ({
      url: '/api/douyin_aweme',
      method: 'get',
      params
    });
  }

  export function douyin_aweme2(params) {
    return request({
        url: '/api/douyin_aweme2',
        method: 'get',
        params
    })
}
export function douyin_aweme3(params) {
  return request({
      url: '/api/douyin_aweme3',
      method: 'get',
      params
  })
}

export function douyin_aweme4(params) {
  return request({
      url: '/api/douyin_aweme4',
      method: 'get',
      params
  })
}

export function douyin_aweme5(params) {
  return request({
      url: '/api/douyin_aweme5',
      method: 'get',
      params
  })
}

export function douyin_aweme6(params) {
  return request({
      url: '/api/douyin_aweme6',
      method: 'get',
      params
  })
}

export function douyin_aweme7(params) {
  return request({
      url: '/api/douyin_aweme7',
      method: 'get',
      params
  })
}

export function douyin_aweme8(params) {
  return request({
      url: '/api/douyin_aweme8',
      method: 'get',
      params
  })
}


  export function douyin_aweme_comments(params) {
    return request  ({
      url: '/api/douyin_aweme_comment',
      method: 'get',
      params
    });
  }
  export function douyin_aweme_comments2(params) {
    return request  ({
      url: '/api/douyin_aweme_comment2',
      method: 'get',
      params
    });
  }

  export function douyin_aweme_comments3(params) {
    return request  ({
      url: '/api/douyin_aweme_comment3',
      method: 'get',
      params
    });
  }

  export function douyin_aweme_comments4(params) {
    return request  ({
      url: '/api/douyin_aweme_comment4',
      method: 'get',
      params
    });
  }

  export function douyin_aweme_comments5(params) {
    return request  ({
      url: '/api/douyin_aweme_comment5',
      method: 'get',
      params
    });
  }



  export function douyin_aweme_comments6(params) {
    return request  ({
      url: '/api/douyin_aweme_comment6',
      method: 'get',
      params
    });
  }

  export function douyin_aweme_comments7(params) {
    return request  ({
      url: '/api/douyin_aweme_comment7',
      method: 'get',
      params
    });
  }


  export function douyin_aweme_comments8(params) {
    return request  ({
      url: '/api/douyin_aweme_comment8',
      method: 'get',
      params
    });
  }

  export function douyin_aweme_comments9(params) {
    return request  ({
      url: '/api/douyin_aweme_comment9',
      method: 'get',
      params
    });
  }
 
  export function douyin_aweme_comments10(params) {
    return request  ({
      url: '/api/douyin_aweme_comment10',
      method: 'get',
      params
    });
  }
 
  export function douyin_aweme_comments11(params) {
    return request  ({
      url: '/api/douyin_aweme_comment11',
      method: 'get',
      params
    });
  }
  
  export function douyin_aweme_comments12(params) {
    return request  ({
      url: '/api/douyin_aweme_comment12',
      method: 'get',
      params
    });
  }
  

export function dy_create_task(params) {
  return request  ({
    url: '/api/tasks',
    method: 'get',
    params
  });
}

export function create_task(params) {
  return request({
    url: '/api/tasks',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  });
}


export function start_crawler(params) {
  return request({
    url: '/start_crawler',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  });
}


export function deleteTask(taskId) {
  return request({
    url: `/tasks/${taskId}`, // 使用模板字符串插入 taskId
    method: 'delete',
  });
}

export function delete_douyin_aweme(user_id) {
  return request({
    url: `/api/douyin_aweme/${user_id}`, // 使用模板字符串插入 taskId
    method: 'delete',
  });
}

export function delete_douyin_aweme2(user_id) {
  return request({
      url: `/api/douyin_aweme2/${user_id}`,
      method: 'delete'
  })
}
export function delete_douyin_aweme4(user_id) {
  return request({
      url: `/api/douyin_aweme2/${user_id}`,
      method: 'delete'
  })
}




export function delete_douyin_aweme_comment(user_id) {
  return request({
    url: `/douyin_aweme_comment/${user_id}`, // 使用模板字符串插入 taskId
    method: 'delete',
  });
}

export function douyin_count(params) {
  return request({
    url: '/douyin_count',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  });
}

export function douyin_count2(params) {
  return request  ({
    url: '/api/douyin_count',
    method: 'get',
    params
  });
}

export function delete_count(id) {
  return request({
    url: `api/count/${id}`, 
    method: 'delete',
  });
}
